"use client";

import Skeleton from "@/components/feedback/Skeleton";
import { breakpointClasses, cn, splitBreakpointProps } from "@/lib/utils";
import type { CarouselItemProps } from "../types";
import { useCarouselStore } from "./carousel-provider";

function CarouselItem({
  index,
  forceMount = false,
  className,
  children,
  ...props
}: CarouselItemProps) {
  const orientation = useCarouselStore(state => state.orientation);
  const isMounted = useCarouselStore(state => state.mountedSlides).has(index);
  const totalSlides = useCarouselStore(state => state.totalSlides);

  const { bp, native } = splitBreakpointProps(props);
  const classes = breakpointClasses(bp);

  return (
    <div
      role="group"
      aria-roledescription="slide"
      aria-label={`Slide ${index + 1} of ${totalSlides}`}
      data-slot="carousel-item"
      className={cn(
        "relative min-w-0 shrink-0 grow-0",
        orientation === "horizontal" ? "pl-4" : "pt-4",
        className,
        classes,
      )}
      {...native}
    >
      {isMounted || forceMount ? (
        children
      ) : (
        <Skeleton aria-hidden className="h-auto min-h-[inherit]" />
      )}
    </div>
  );
}

export default CarouselItem;
